import React, {Component} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../CSS/LoginPage.css';
//import Promise from 'promise-polyfill';
import AppointmentService from '../utils/AppointmentService.js';
import AuthService from '../utils/AuthService.js';
import NewCCForm from './NewCCForm.js';
import { Switch, Route, Link } from 'react-router-dom'
import moment from 'moment'
import Select from 'react-select';
import HomeIcon from '../images/home.png'
import WorkIcon from '../images/business.png'
import CustomerInfoForm from "../Components/CustomerInfoForm.js"
import SummaryVehicle from "../Components/SummaryVehicle.js"
import Modal from 'react-modal';
import 'react-select/dist/react-select.css';
import Trash from 'react-icons/lib/fa/trash-o';
import { Redirect } from 'react-router-dom'
import { ClipLoader } from 'react-spinners';
import { css } from 'react-emotion';
import ErrorSnackBar from "./ErrorSnackBar";

// if (!window.Promise) {
//   window.Promise = Promise;
// }

const override = css`
    display: block;
    margin: 10% 45%;
    border-color: red;
`;
class Summary extends Component {

  constructor(props) {
    super(props);
    this.Auth = new AuthService()
    this.Appt = new AppointmentService()
    this.state = {
      make: '',
      model: '',
      make_id: '',
      model_id: '',
      color: '',
      year: '',
      years: [],
      user: props.user,
      yearOptions: [],
      makeOptions: [],
      apptTotal: 0,
      modalOpen: false,
      creditCardOptions: [],
      creditCard: null,
      promo_code: null,
      promoModalOpen: false,
      snackErrorOpen: false,
      snackErrorMessage: '',
      promoError: '',
      addCardModal:false,
      showConfirmationModal: false,
      loading: false,
      showDiv: true,
      userInfoModalOpen: false,
      width: document.body.clientWidth,
      ccError: "",
      tax_amount: 0
    };
    this.handleSubmit = this.handleSubmit.bind(this)
    this.closeCCAddModal = this.closeCCAddModal.bind(this)
    this.updateDimensions = this.updateDimensions.bind(this)
    this.openCCModal = this.openCCModal.bind(this)
    this.closePromoWindow = this.closePromoWindow.bind(this)
    this.getCreditCards()
  }
  componentWillMount() {

  }
  componentDidMount() {

    window.addEventListener("resize", this.updateDimensions);
    if(this.props.earlyPromoString)
    {
      this.check_early_promo()
    }
    var packages = this.props.appointmentItems.map(item => {
    return item.serviceId
    })
    var upgrades = this.props.appointmentItems.map(item => {
    return item.upgradeIds
    })
    upgrades = upgrades.flat()
    var promo_amount = 0
    if (this.state.promo_code) {
      promo_amount = this.state.promo_code.discount_amount
    }
    this.Appt.get_tax_amount(packages, upgrades, this.props.appointmentAddress.id, promo_amount)
    .then(res => {
      if (res.amount > 0) {
        this.setState({tax_amount: res.amount})
      }

    })
  }
  componentWillUnmount() {
      window.removeEventListener("resize", this.updateDimensions);
  }
  componentWillReceiveProps(props){

  }
  updateDimensions() {
      this.setState({width: document.body.clientWidth});
  }
  handleCCChange = event => {
    if(event) {
      if (event.value == 'new') {
        this.setState({
          modalOpen: false,
          addCardModal: true,
          creditCard: null
        })
      } else {
        this.setState({creditCard: event});
      }
    }
  }

  apptVehicles() {
    return this.props.appointmentItems.map(item => item.vehicle)
  }

  apptVehiclePackages() {
    return this.props.appointmentItems.map(item => item.service)
  }

  apptVehicleUpgradeIds() {
    return this.props.appointmentItems.map(item => item.upgradeIds)
  }

  getCreditCards() {
    this.Appt.creditCards()
    .then(res =>{
      if(res.errors){
        this.props.setError("Could not retrieve saved credit cards, if problem persists please contact Spiffy (844-438-7743) for assistance.")
      }
      else {
        this.props.setError("")
        var creditCardOptions = []
        var counter = 1
        var defaultCard = {}
        creditCardOptions[0] = {}
        creditCardOptions[0].value = "new"
        creditCardOptions[0].label = "Add New Card"
        res.credit_cards.forEach((cc) => {
          if(cc.default_card == true){
            defaultCard.value = cc.id
            defaultCard.label = cc.brand + " " + cc.last4
          }
          creditCardOptions[counter] = {}
          creditCardOptions[counter].value = cc.id
          creditCardOptions[counter].label = cc.brand + " " +cc.last4
          counter  = counter + 1
        })
        if(!defaultCard.value){
          defaultCard = creditCardOptions[0]
        }
        this.setState({
          creditCardOptions: creditCardOptions,
          creditCard: defaultCard

        })

      }
    })
    .catch(err =>{
      this.props.setError("Could not retrieve saved credit cards, if problem persists please contact Spiffy (844-438-7743) for assistance.")
    })
  }

  setDefaultCard(card_id){
    this.setState({
      loading:true
    })
    this.Appt.setDefaultCard(card_id)
    .then(res =>{

    })
    .catch(err =>{
      throw new Error('Error setting default credit card' + err.message);
    })
  }

  handleSubmit = event =>  {
    if(this.state.creditCard && this.state.creditCard.value){
      if(this.state.creditCard.value == 'new'){
        this.setState({
          modalOpen:false,
          addCardModal: true
        })
      }
      else{
        this.setState({
          modalOpen: false,
          showDiv: false,
          loading:true
        })
      this.Appt.setDefaultCard(this.state.creditCard.value)
        .then(res =>{
          this.submitAppointment()
        })
        .catch(err =>{
          throw new Error('Error setting default credit card' + err.message);
        })
      }
    }
  }
  chooseCreditCard() {
    var user = this.state.user
      if(user && (!user.email || !user.first_name || !user.last_name || !user.phone)){
        this.setState({
          userInfoModalOpen: true
        })
      }
      else {
        this.openCCModal();
    }
  }
  openCCModal() {
    this.setState({
      modalOpen: true
    })
  }
  closeCCAddModal() {
    this.setState({
      addCardModal: false
    })
  }
  setLoadingTrue = () =>{
    this.setState({
      modalOpen: false,
      showDiv: false,
      addCardModal: false,
      loading:true
    })
  }
  saveUser = (user) => {
    this.setState({
      userInfoModalOpen:false,
      user: user
    })
    this.openCCModal()
  }
  submitAppointment = () => {
    this.setState({
      modalOpen: false,
      showDiv: false,
      addCardModal: false,
      loading:true
    })
    if(this.state.creditCard && this.state.creditCard.value && this.state.creditCard.value != 'new'){

      this.Appt.setDefaultCard(this.state.creditCard.value)
      .then(res =>{
        this.Appt.createAppointment(this.props.appointmentAddress.id, this.props.apptDateTime, this.apptVehiclePackages(), this.apptVehicles(), this.apptVehicleUpgradeIds(), this.state.promoString)
        .then(res =>{
          if(res && res.errors){
            this.setState({
              loading: false,
              showDiv: true
            })
            throw new Error('Error creating appointment - response returned an error:' + res.errors);
            this.props.setError("The appointment could not be submitted at this time, contact our penguins for help scheduling an appointment.")
          }
          else if(res){
            this.setState({
              loading:false,
              showConfirmationModal: true
            })
            localStorage.removeItem('appointmentAddress')
            localStorage.removeItem('appointmentVehicles')
            localStorage.removeItem('appointmentVehicle')
            localStorage.removeItem('appointmentServices')
            localStorage.removeItem('allUpgradesArray')
            localStorage.removeItem('allUpgradesMap')
            localStorage.removeItem('appointmentUpgrades')
            localStorage.removeItem('promoAmount')
            localStorage.removeItem('apptDateTime')
            localStorage.removeItem('appointmentPackage')
          }
          else {
            throw new Error('Error creating appointment - response not valid:');
            this.props.setError("The appointment could not be submitted at this time, contact our penguins for help scheduling an appointment.")
            this.setState({
              loading:false,
              showDiv: true
            })
          }

        })
        .catch(err =>{
          this.props.setError("The appointment could not be submitted at this time, contact our penguins for help scheduling an appointment." + err.toString())
          throw new Error('Error creating appointment' + err.message);
          this.setState({
            loading:false,
            showDiv: true
          })
        })
      })
      .catch(err =>{
        throw new Error('Error creating appointment' + err.message);
        this.props.setError("The appointment could not be submitted at this time, contact our penguins for help scheduling an appointment." + err.toString())
        this.setState({
          loading:false,
          showDiv: true
        })
      })
    }
    else {
      this.Appt.createAppointment(this.props.appointmentAddress.id, this.props.apptDateTime, this.apptVehiclePackages(), this.apptVehicles(), this.apptVehicleUpgradeIds(), this.state.promoString)
      .then(res =>{
        if(res && res.errors){
          this.setState({
            loading: false,
            showDiv: true
          })
          throw new Error('Error creating appointment - response returned an error:' + res.errors);
          this.props.setError("The appointment could not be submitted at this time, contact our penguins for help scheduling an appointment.")
        }
        else if(res){
          this.setState({
            loading:false,
            showConfirmationModal: true
          })
          localStorage.removeItem('appointmentAddress')
          localStorage.removeItem('appointmentVehicles')
          localStorage.removeItem('appointmentVehicle')
          localStorage.removeItem('appointmentServices')
          localStorage.removeItem('allUpgradesArray')
          localStorage.removeItem('allUpgradesMap')
          localStorage.removeItem('appointmentUpgrades')
          localStorage.removeItem('promoAmount')
          localStorage.removeItem('apptDateTime')
          localStorage.removeItem('appointmentPackage')
        }
        else {
          throw new Error('Error creating appointment - response not valid:');
          this.props.setError("The appointment could not be submitted at this time, contact our penguins for help scheduling an appointment.")
          this.setState({
            loading:false,
            showDiv: true
          })
        }

      })
    }
  }
  addToTotal(vehicleTotal) {
    var total = this.state.apptTotal
    total += vehicleTotal
    this.setState({
      apptTotal: total
    })
  }
  promoPopup() {
    this.setState ({
      promoModalOpen: true
    })
  }

  check_promo(){
    this.Appt.get_valid_promo(this.props.appointmentPackages, this.props.appointmentSelectedUpgrades, this.state.promoString)
    .then(res =>{
      if(res && res.promo){
        this.setState({
          promo_code: res,
          promoModalOpen: false
        })
      }
      else if(res){
        this.setState({
          promoError: res.error
        })
      }
      if(res.errors){
        this.setState({
          promoResult: res.errors
        })
        throw new Error('Invalid response for promo_code' + this.state.promo_code);
      }
    })
    .catch(err => {
      throw new Error('Error checking promo code - ' + this.state.promo_code + ":" + err.message);
    })
  }

  check_early_promo(){
    let early_promo_code = this.props.earlyPromoString;
    if(this.props.clearEarlyPromo)
    {
      this.props.clearEarlyPromo()
    }

    this.Appt.get_valid_promo(this.props.appointmentPackages, this.props.appointmentSelectedUpgrades, early_promo_code)
        .then(res =>{
          if(res && res.promo){
            this.setState({
              promo_code: res,
              promoModalOpen: false
            })
          }
          else if(res){
            let error_text = res.error;
            let rep_error_text = error_text.replace('The promo code entered was invalid', `The promo code '${early_promo_code}' was invalid`)
            this.setState({
              snackErrorOpen: true,
              snackErrorMessage: rep_error_text
            })
          }
          if(res.errors){
            this.setState({
              snackErrorOpen: true,
              snackErrorMessage: res.errors
            })
            throw new Error('Invalid response for promo_code' + early_promo_code);
          }
        })
        .catch(err => {
          throw new Error('Error checking promo code - ' + early_promo_code + ":" + err.message);
        })
  }

  onSnackErrorClosed = () => {
    this.setState({
      snackErrorOpen: false,
      snackErrorMessage: ''
    })
  }

  handleChange = event => {
    this.setState({promoString: event.target.value});
  }
  loginUser = (username, password) => {
    var guest_id = localStorage.getItem('customer_id')
    this.Auth.merge_guest_and_logn(username, password, guest_id)
      .then(res =>{
        if(res.errors){
          this.props.setError("Password is Incorrect")
        }
        else {
          this.props.setError('')
          localStorage.setItem('id_token', res.auth_token)
          localStorage.setItem('customer_id', res.id)
          this.setState({
            userInfoModalOpen: false,
            user: res
          })
          //window.location.reload()
          this.props.setVariables()
        }
      })
      .catch(err =>{
        //throw new Error('Error setting default credit card' + err.message);
      })
        //set all appointment data in local storage
    //merge and create guest accoutBalanceTowardAppt
    //go to home page

  }

  removePromo() {
    this.setState({
      promo_code: null
    })
  }
  closePromoWindow() {
    this.setState({
      promoModalOpen:false,
      promoString: null
    })
  }
  returnToDashboard() {
    window.location.href = '../';
  }
  render(){
    var user = this.state.user
    var moreInforNeeded = false
    if(user){
      if(!user.email || !user.first_name || !user.last_name || !user.phone_number)
        moreInforNeeded = true
    }
    var discountAmount = 0
    var discountPromo = 0
    if(this.state.promo_code){
      discountPromo = parseFloat(this.state.promo_code.discount_amount.toFixed(2))
    }
      var vehiclesHTML = []
      if(this.props.appointmentVehicles){
        var i = 0
        var this_2 = this
        var costTotal = 0
        this.props.appointmentItems.forEach(function(item, index) {
          //console.log("vehicle item: ", item)
          vehiclesHTML.push(<SummaryVehicle key={index} upgrades={item.upgrades} vehicle={item.vehicle} service={item.service} />)

          item.upgrades.forEach(function(upgrade){
            var upgradeAmt = upgrade.amount
            if(upgradeAmt > 0)
              costTotal += parseFloat(upgradeAmt)
          })

          if(item.service.amount > 0 ){
            costTotal += item.service.amount
            if(!this_2.state.promo_code){

              discountAmount += (item.service.amount - item.service.amount_after_promo)/100
            }
          }
        });
      }

    //  totalAmount += this.props.appointmentPackage.amount/100
      var dateString = ""
      dateString = moment(this.props.apptDateTime).format("dddd, MMMM Do YYYY @ h:mm a");
      var ccValue = null
      if(this.state.creditCard){
        ccValue = this.state.creditCard.id
      }

      const customStyles =
      this.state.width < 780 ?
      {
        content: {
          top                   : '0%',
          left                  : '0%',
          right                 : 'auto',
          bottom                : 'auto',
          padding               : '0px'
        }
      }:
        {
          content: {
            top                   : '50%',
            left                  : '50%',
            right                 : 'auto',
            bottom                : 'auto',
            transform             : 'translate(-50%, -50%)',
            padding               : '0px'
          }
        }
      const customStyles2 =
      this.state.width < 780 ?
      {
        content: {
          top                   : '10%',
          left                  : '0%',
          height                : '70%',
          width                 : '100%',
          padding               : '0px',
          right                 : 'auto',
          color                 : 'white',
        }
      }:
        {
          content: {
            top                   : '10%',
            left                  : '15%',
            height                : '62%',
            width                 : '70%',
            padding               : '0px',
            right                 : 'auto',
            color                 : 'white',
          }
        }
        const newCCStyles =
        this.state.width < 780 ?
        {
          content: {
            width: '98%',
            left:'1%',
            height: '35%',
            padding: '0px !important'
          }
        }:
          {
            content: {
              width: '50%',
              left:'25%',
              height: '35%',
              padding: '0px !important'
            }
          }
      var button = null
      if((this.props.appointmentAddress && this.props.appointmentAddress.rdi == 'Residential' && this.props.appointmentAddress.cbu.minimum_order > ((this.props.appointmentAddress.tax_rate/100) * (costTotal/100) + (costTotal/100)).toFixed(2))){
        button = <a className="btn btn-success summaryButton">Minimum Not Met</a>
      }
      else{
        button = <a className="btn btn-success summaryButton" onClick={() => this.chooseCreditCard()} href="#">Next</a>
      }
      var total = 0

      total += parseFloat(costTotal/100)
      if(this.props.appointmentAddress && !this.props.appointmentAddress.client_host && this.props.appointmentAddress.travel_fee && this.props.appointmentAddress.travel_fee_minimum > (costTotal/100)){
        total += parseFloat(this.props.appointmentAddress.travel_fee)
      }
      if(this.state.promo_code){
        total = total - discountPromo
      }
      if(discountAmount){
        total = total - discountAmount
      }
      var totalWithoutTax = total
      var tax_amount
      if (this.state.tax_amount > 0) {
        tax_amount =this.state.tax_amount
      }
      else {
        tax_amount = parseFloat(this.props.appointmentAddress.tax_rate/100) * parseFloat(totalWithoutTax)
      }
      total += tax_amount
      return (
        <div>
        <ErrorSnackBar onSnackClosed={this.onSnackErrorClosed} color = {'#c42d2d'} open={this.state.snackErrorOpen} message = {this.state.snackErrorMessage}/>
        {this.state.showDiv &&
          <div className="card">
            <div className="card-title blue-background text-white text-center">
              <h4>Request your Spiffy</h4>
            </div>
            <div className="card-subtitle bg-light text-center">
              <h5 className="dateFont">Preferred Date and Time</h5>
              <h5 className="dateFont">{dateString}</h5>
            </div>
            <div className="card-title bg-white">
              <div className="row align-items-center mb-2">
                <div className="col">
                  <h6 className="card-subtitle ml-3">Location: {this.props.appointmentAddress.display_title}<br></br>{this.props.appointmentAddress.street}</h6>
                </div>
                <div className="col text-right mr-3">
                {(this.props.appointmentAddress.rdi == 'Residential') &&
                  <img width="15%" src={HomeIcon}></img>}
                {(this.props.appointmentAddress.rdi != 'Residential') &&
                    <img width="60px" src={WorkIcon}></img> }
                </div>
              </div>
            </div>
            <div>{vehiclesHTML}</div>
            <hr></hr>
            <div className="card-title">
              <div className="card-title bg-white">
                <div className="row no-gutters align-items-center">
                <div className="twoColumn">
                  <h6 className="halfDiv padding-ten">Base Amount</h6>
                  <h6 className="halfDiv textAlignRight2"> ${(costTotal/100).toFixed(2)}</h6>
                </div>
                {(this.props.appointmentAddress && this.props.appointmentAddress.travel_fee > 0 && !this.props.appointmentAddress.client_host && this.props.appointmentAddress.travel_fee_minimum > (costTotal/100)) &&
                  <div className="twoColumn">
                    <h6 className="halfDiv padding-ten">Travel Fee:</h6>
                    <h6 className="halfDiv textAlignRight2"> ${(this.props.appointmentAddress.travel_fee.toFixed(2))}</h6>
                  </div>
                }


                  {this.state.promo_code &&
                    <div className="twoColumn">
                      <div className="threeQuarterDiv padding-ten">
                        <h6> Promo Code
                        <br></br>
                      ({this.state.promo_code.promo.title})<Trash onClick={() => this.removePromo()}/></h6>
                      </div>
                      <h6 className="halfDiv textAlignRight2"> - $ {this.state.promo_code.discount_amount.toFixed(2)}</h6>
                    </div>
                  }
                  {(discountAmount > 0 && !this.state.promo_code)  &&
                    <div className="twoColumn">
                      <h6 className="halfDiv padding-ten"> Promo Code </h6>
                      <h6 className="halfDiv textAlignRight2"> - $ {(discountAmount).toFixed(2)}</h6>
                    </div>
                  }
                  <div className="twoColumn">
                    <div className="threeQuarterDiv padding-ten">
                      <h6>Sales Tax:</h6>
                    </div>
                    <h6 className="halfDiv textAlignRight2"> ${tax_amount.toFixed(2)}</h6>
                  </div>
                  <div className="twoColumn">
                    <h6 className="halfDiv padding-ten">Total:</h6>
                    <h6 className="halfDiv textAlignRight2">${total.toFixed(2)}</h6>
                  </div>
              </div>
                <div className="card-title text-center mt-2 mb-0">
                <a className="btn btn-primary summaryButton"  onClick={() => this.props.addVehicle()}>Add Vehicle?</a>
                {!this.state.promo_code &&
                  <a className="btn btn-primary summaryButton" onClick={() =>this.promoPopup()} href="#">Add Promo Code</a>
                }
                {button}

              </div>
              </div>
            </div>
            <Modal
              isOpen={this.state.userInfoModalOpen}
              contentLabel="Example Modal"
              style={customStyles2}
              >
              <CustomerInfoForm loginUser = {this.loginUser} saveUser = {this.saveUser} user={this.state.user}/>
            </Modal>
            <Modal
              isOpen={this.state.modalOpen}
              contentLabel="Example Modal"
              style={customStyles}
              >

              {this.state.creditCardOptions.length > 0 && <div>
                <div className="card-header blue-background text-white text-center dateTimeContainer ">
                  <h4>Please Select A Credit Card</h4>
                </div>
                <div className="paddingTen">
                  <Select
                      name="form-field-name"
                      value={this.state.creditCard}
                      onChange={this.handleCCChange}
                      options={this.state.creditCardOptions}
                  />
                  <p>Providing your credit card allows Spiffy to confirm availability of funds as a “hold”. If you cancel within 24-hrs of scheduled start, you may receive a $15 fee to cover re-routing Technicians</p>
                  <a className="btn btn-success fullWidth" onClick={() => this.handleSubmit()} href="#">Confirm</a>
                  <button onClick = {() => this.setState({modalOpen: false})}className="btn btn-block text-muted text-center">Cancel</button>
                </div>
              </div>}
              {this.state.creditCardOptions.length <= 0 && <div>
                <div className="card-header blue-background text-white text-center dateTimeContainer ">
                  <h4>Please Select A Credit Card</h4>
                </div>
                <div className="paddingTen">
                  <p>An error occured with the credit card service, if problem persists please contact Spiffy (844-438-7743) for assistance.</p>
                  <div className="card-title text-center mt-2 mb-0">
                    <a className="btn btn-primary summaryButton" onClick={() => this.setState({modalOpen: false})}href="#">OK</a>
                  </div>
                </div>
              </div>}
            </Modal>
            <Modal
              isOpen={this.state.promoModalOpen}
              contentLabel="Example Modal"
              style={customStyles}
              >
              <div className="promoCodeModal">
                <div className="card-header blue-background text-white text-center dateTimeContainer ">
                  Add Promo Code
                </div>
                <div className="paddingTen">
                  <h6>If you have a valid promo code, we will apply it to your appointment </h6>
                  { discountAmount > 0 &&
                    <h6>Adding a promo code will remove your partner discount </h6>
                  }
                  <input value={this.state.promoString} onChange={this.handleChange} className="promoInput"></input>
                  <button className="btn btn-primary promoAdd" onClick={() =>this.check_promo()}>Submit</button>
                  <button onClick = {() => this.closePromoWindow()}className="btn btn-block text-muted text-center">Cancel</button>
                  <h6 id="promoErrorSummary">{this.state.promoError}</h6>
                </div>
              </div>
            </Modal>
            <Modal
              isOpen={this.state.addCardModal}
              contentLabel="Example Modal"
              style={newCCStyles}
              >
              <div>
                <div className="card-header blue-background text-white text-center dateTimeContainer ">
                  <h4>Add New Card</h4>
                </div>
                <NewCCForm ccErrors = {this.state.ccErrors} afterSave={this.submitAppointment} closeModal={this.closeCCAddModal} onLoad={this.setLoadingTrue}/>
              </div>
            </Modal>



          </div>
        }
        {!this.state.showDiv &&
          <div>
            <Modal
              isOpen={this.state.showConfirmationModal}
              contentLabel="Example Modal"
              style={customStyles}
              >
              <div className="card-header blue-background text-white text-center dateTimeContainer ">
                <h4>Request Sent</h4>
              </div>
              <div className="paddingTen">
                <p>We will notify you when we confirm your Spiffy</p>
                <button className="btn btn-primary promoAdd" onClick={() => this.returnToDashboard()}>Close</button>
                <br></br>
              </div>
            </Modal>
            <Modal
              isOpen={this.state.loading}
              contentLabel="Example Modal"
              style={newCCStyles}
              >
              <div className="card-header blue-background text-white text-center dateTimeContainer ">
                <h4>Loading</h4>
              </div>
              <div className="topDiv">
                <ClipLoader
                  className={override}
                  sizeUnit={"px"}
                  size={100}
                  color={'#164070'}
                  loading={this.state.loading}
                />
              </div>
            </Modal>
          </div>

        }
        </div>

              )
    }
}
export default Summary;



// WEBPACK FOOTER //
// ./src/Components/Summary.js